import { Box, SvgIcon } from "@mui/material";
import Button from "../FormFields/Button";
import { useEffect, useRef, useState } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

export default function ScrollableToBottomContainer({
  isMobile,
  hideButton,
  label,
}: any) {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const scrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current?.parentElement?.lastElementChild?.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  const scrollToTop = () => {
    if (containerRef.current?.parentElement) {
      containerRef.current.parentElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      containerRef.current.parentElement?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  const lastChildVisibility = useLastChildVisibility(
    containerRef.current?.parentElement
  );
  const toMobile = isMobile
    ? {
        padding: "0px",
        margin: "0px",
      }
    : {};

  return (
    <Box
      ref={containerRef}
      style={{
        zIndex: 1200,
        position: "sticky",
        float: "left",
        top: 0,
        padding: "10px",
        ...toMobile,
      }}
    >
      {!hideButton &&
        (lastChildVisibility ? (
          <SvgIcon
            sx={{
              padding: 0,
              fontSize: 50,
              margin: 0,
              ...toMobile,
            }}
            style={toMobile}
            onClick={scrollToTop}
          >
            <ArrowUpwardIcon
              sx={{
                padding: 0,
                margin: 0,
                ...toMobile,
              }}
              style={toMobile}
              color="error"
              fontSize={isMobile ? "small" : "large"}
            />
          </SvgIcon>
        ) : (
          <Button
            color="info"
            label={label}
            size={isMobile ? "small" : "large"}
            onClick={scrollToBottom}
          />
        ))}
    </Box>
  );
}

function useLastChildVisibility(parentElement: any) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsIntersecting(entry.isIntersecting),
      { rootMargin: "0px 0px", threshold: 0.1 }
    );

    if (parentElement && parentElement.lastElementChild) {
      observer.observe(parentElement.lastElementChild);
    }

    return () => {
      if (parentElement && parentElement.lastElementChild) {
        observer.unobserve(parentElement.lastElementChild);
      }
    };
  }, [parentElement]);

  return isIntersecting;
}

//   const [isIntersecting, setIsIntersecting] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(([entry]) =>
//       setIsIntersecting(entry.isIntersecting),
//       { rootMargin: '0px 0px', threshold: 0 }
//     );

//     if (containerRef.current?.parentElement?.lastElementChild) {
//       observer.observe(containerRef.current?.parentElement?.lastElementChild);
//     }

//     return () => {
//       if (containerRef.current?.parentElement?.lastElementChild) {
//         observer.unobserve(containerRef.current?.parentElement?.lastElementChild);
//       }
//     };
//   }, [containerRef.current?.parentElement?.lastElementChild]);
